import { RiLockLine } from "@remixicon/react";
import { cn } from "cn";
import type { ComponentProps } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

interface LockedInlineProps extends Omit<ComponentProps<"span">, "children"> {
  /** Что закрыто: «Пометки ММ», «Подходы». */
  label: string;
  /** Пояснение, чем открывается. */
  text: string;
}

/** Замок в строке или шапке: значок с подсказкой и той же фразой в доступном имени. */
function LockedInline({ label, text, className, ...props }: LockedInlineProps) {
  const hint = `${label}: ${text}`;
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span
            data-slot="locked-inline"
            role="img"
            aria-label={hint}
            className={cn("inline-flex text-muted-foreground", className)}
            {...props}
          />
        }
      >
        <RiLockLine className="size-3" />
      </TooltipTrigger>
      <TooltipContent>{hint}</TooltipContent>
    </Tooltip>
  );
}

export { LockedInline };
